import { createFileRoute } from '@tanstack/react-router'

import { AdminSidebarContainer } from '@/components/app/admin-sidebar-container'
import { AdminIdentitiesContainer } from '@/components/screens/admin/admin-identities-container'

export const Route = createFileRoute('/admin/identities')({ component: Page })

function Page() {
  return (
    <div className="flex min-h-screen bg-background">
      <AdminSidebarContainer />
      <main className="min-w-0 flex-1 px-4 py-6 sm:px-6 lg:px-8 xl:px-10">
        <AdminIdentitiesContainer />
      </main>
    </div>
  )
}
